import { Box } from '@mui/material';
import { isMobileDevice } from '../../../../helpers/common';
import Channel from '../../../SendBird/Channel';
import { SendbirdUIKitProvider } from '../../../SendBird/SendbirdUIKitProvider';
import { defaultSendbirdGroupChannelUikitOptions } from '../../../../constants/sendbirdConstants';
import './chatPageSendbirdChat.scss';

const ChatPageSendbirdChat = ({
  channelUrl,
  isNewModelChannel = false,
  vendorSendBirdId = null,
  onMessageUpdates,
  onChannelPreviewUpdate,
  showLatestIcon = false,
}: {
  channelUrl: string;
  isNewModelChannel?: boolean;
  vendorSendBirdId?: string | null;
  showLatestIcon?: boolean;
  onMessageUpdates: () => void;
  onChannelPreviewUpdate?: (channelUrl: string, lastMessage: unknown) => void;
}) => {
  return (
    <Box className={`chatPageSendbirdChatContainer ${isMobileDevice().isIOS || isMobileDevice().isAndroid ? `chatPageSendbirdChatContainer__mobileDevice__${isMobileDevice().isIOS ? 'ios' : 'android'}` : ''}`}>
      <SendbirdUIKitProvider
        isNewModelChannel={isNewModelChannel}
        vendorSendBirdId={vendorSendBirdId}
        channelUrl={channelUrl}
        embedded
        uikitOptions={{
          groupChannel: {
            ...defaultSendbirdGroupChannelUikitOptions,
            typingIndicatorTypes: new Set(['bubble']),
          },
        }}
      >
        <Channel
          onMessageUpdates={onMessageUpdates}
          onChannelPreviewUpdate={onChannelPreviewUpdate}
          url={channelUrl}
          showLatestIcon={showLatestIcon}
        />
      </SendbirdUIKitProvider>
    </Box>
  );
};

export default ChatPageSendbirdChat;
